import PropTypes from 'prop-types';
import styled from 'helpers/styles';
import ComponentStyles from 'styles/mixins/Component.styles';
import Card from '@mui/material/Card';
import constants from 'helpers/constants';
import {rgba} from 'polished';
import utils from 'helpers/utils';

const StyledCard = styled(Card)
  .attrs((props) => {
    let attr = props;

    const baseColorVars = props.theme.color2Css('Card', null, props.$color, {
      varPrefix: 'card',
      variables: true,
      interactive: false,
      type: constants.colorTypes.accentBackground
    });

    attr = utils.styleProps(attr, baseColorVars.vars, {baseColor: baseColorVars.css});

    const clickableColorVars = props.theme.color2Css('Card', null, props.$color, {
      variables: true,
      varPrefix: 'card-clickable',
      interactive: true,
      type: constants.colorTypes.accentBackground
    });

    attr = utils.styleProps(attr, clickableColorVars.vars, {clickableColor: clickableColorVars.css});

    const vars = {
      '--card-outlined-selected-color': props.theme.property(`palette.${props.$color}.main`),
      '--card-outlined-selected-border-color': props.theme.property(`palette.${props.$color}.main`),
      '--card-outlined-disabled-color': rgba(props.theme.property(`palette.${props.$color}.main`), props.theme.property('palette.action.disabledOpacity')),
      '--card-outlined-disabled-border-color': rgba(props.theme.property(`palette.${props.$color}.main`), props.theme.property('palette.action.disabledOpacity')),
      '--card-clickable-focus-background-color': props.theme.property('palette.background.paper')
    };

    return utils.styleProps(attr, vars);
  })`
  outline: none;

  &.Card-isLoading {
    pointer-events: none;
  }
  
  &:not(.Card-isLoading) {
    ${props => props.$css.baseColor}
  }

  &.Card {
    ${props => props.theme.state2Selector('Card', null, 'disabled')} {
      pointer-events: none;
      cursor: default;
      opacity: 0.6;
    }
  }
  
  &.Card-outlined {
    ${props => props.theme.state2Selector('Card', null, ['selected'])} {
      color: ${props => props.$css.$var('--card-outlined-selected-color')};
      border-color: ${props => props.$css.$var('--card-outlined-selected-border-color')};
    }
    
    ${props => props.theme.state2Selector('Card', null, 'disabled')} {
      color: ${props => props.$css.$var('--card-outlined-disabled-color', false)} !important;
      border-color: ${props => props.$css.$var('--card-outlined-disabled-border-color', false)} !important;
    }
  }

  &.Card-clickable {
    ${props => props.$css.clickableColor}
    
    cursor: pointer;

    &:not(.Card-focusable) {
      ${props => props.theme.state2Selector('Card', null, ['focus', 'focusVisible'])} {
        background-color: ${props => props.$css.$var('--card-clickable-focus-background-color', false)} !important;
      }
    }
  }

  &.Card-radius-round {
    border-radius: ${props => props.theme.radius(2)};
  }
  &.Card-radius-rounder {
    border-radius: ${props => props.theme.radius(3)};
  }
  &.Card-radius-roundest {
    border-radius: ${props => props.theme.radius(4)};
  }
  &.Card-radius-square {
    border-radius: ${props => props.theme.radius(0)};
  }

  &.Card-fullHeight {
    height: 100% !important;
  }
  &.Card-fullWidth {
    width: 100% !important;
  }
  
  ${ComponentStyles}
`;

StyledCard.propTypes = {
  theme: PropTypes.object
};

export default StyledCard;
